import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "../TemplateManager.scss";

export const Smu01 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  /**
   * Synchronizes component state with the content of the currently selected slide in Smu01.js.
   *
   * This `useEffect` hook is executed whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's title and content.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the slide's title.
   * - Sets the `content` state with the slide's content.
   *
   * This ensures that the component accurately represents the content of the current slide, allowing for
   * effective editing and previewing within an active session.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setContent(slide.content.content);
    }
  }, [slideId]);

  return (
    <div className="row">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <div className="show-slide__body">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
});
